module.exports = __webpack_public_path__ + "static/media/dropdownIcon.01c06685.svg";